import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

@Injectable()
export class QrCodeProvider {

  constructor(public http:HttpProvider) { }

  /**
   * 获取拉新任务列表 （已catch）*/
  getActEvents(page,pagesize){
    let params = {
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/acquisition/get_list',params);
  }

  deleteOneAcq(page,pagesize,acquisition_id){
    let params = {
      page:page,
      pagesize:pagesize,
      acquisition_id:acquisition_id
    };
    return this.http.hPost('/acquisition/delete',params);
  }

  /**
   * （已catch）*/
  eventInit(){
    return this.http.hPost('/events_init');
  }

  /**
   * 获取任务详情 （已catch）*/
  getEventDetail(id){
    return this.http.hPost('/acquisition/get_detail',{acquisition_id: id});
  }

  getWelcomeDetail(id){
    return this.http.hPost('/welcome/get_detail',{welcome_id:id});
  }

  getWelcomeList(page,pagesize){
    return this.http.hPost('/welcome/get_list',{page:page,pagesize:pagesize});
  }

  welcomeOperate(params){
    return this.http.hPost('/welcome/operate',params);
  }

  /**
   * 新建活动 （已catch）*/
  createEvent(param){
    return this.http.hPost('/events_create', param);
  }

  /**
   * 修改活动信息 （已catch）*/
  modifyEvent(param){
    return this.http.hPost('/events_modify_v2', param);
  }

  /**
   * 验证群名可不可用 （已catch）*/
  validateStartName(param){
    return this.http.hPost('/events_same_start_name', param);
  }

  /**
   * 获取拉新自动回复数据*/
  getAutoWordList(eventId){
    return this.http.hPost('/events_auto_word_list', {event_id: eventId});
  }

  /**
   * 打开/关闭 大类的功能*/
  switchType(params){
    return this.http.hPost('/events_switch_reply', params);
  }

  /**
   * 删除一条自动回复规则*/
  deleteRule(ruleId){
    return this.http.hPost('/events_delete_reply', {id: ruleId});
  }

  /**
   * 编辑一条自动回复规则*/
  editReply(params){
    params['is_work'] = true;
    // delete params.condition_num;
    return this.http.hPost('/events_edit_reply', params);
  }

  getDisabledChatrooms(event_id?){
    return this.http.hPost('/acquisition/get_disabled_chatroom_list',{acquisition_id:event_id})
  }

  getWelcomeDisChatrooms(event_id?){
    return this.http.hPost('/welcome/get_disabled_chatroom_list',{welcome_id:event_id})
  }

  acquisitionOperate(acq){
    return this.http.hPost('/acquisition/operate',acq)
  }

  deleteCondition(condition_id){
    return this.http.hPost('/welcome/condition_delete',{condition_welcome_id:condition_id})
  }

  deleteWelcome(id,page,pagesize){
    let params ={
      welcome_id:id,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/welcome/delete',params)
  }

  deleteChatroom(acq_id,chatroomname){
    let params = {
      acquisition_id:acq_id,
      chatroomname:chatroomname
    };
    return this.http.hPost('/acquisition/chatroom_delete',params);
  }

  deleteWelcomeChatroom(welcome_id,chatroomname){
    let params = {
      welcome_id:welcome_id,
      chatroomname:chatroomname
    };
    return this.http.hPost('/welcome/chatroom_delete',params);
  }


}



// WEBPACK FOOTER //
// ./src/providers/qr-code/qr-code.ts